"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1781],{

/***/ 21781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _7_testimonials_Testimonials; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 5 modules
var Modal = __webpack_require__(78586);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(86529);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/lib/styles.css
var styles = __webpack_require__(48318);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
;// CONCATENATED MODULE: ./public/assets/images/home/ApostropheImg.webp
/* harmony default export */ var ApostropheImg = ({"src":"/_next/static/media/ApostropheImg.a0f67715.webp","height":95,"width":118,"blurDataURL":"data:image/webp;base64,UklGRqAAAABXRUJQVlA4WAoAAAAQAAAABwAABQAAQUxQSDEAAAAA0P//iGb//+3n//+gff///+T//6B6////L0vcjRBKkPUumfQpEmDqite8NQBz3nYDAFZQOCBIAAAA8AEAnQEqCAAGAAJAOCUAToAelyOKhrgAAP7z0E83QFYTOH53Io8T0v4rKIqdlfjcznuZm5cY37P7R8QSv+cmBJWOQqRhb4AA","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/assets/images/home/ApostropheImgInverted.webp
/* harmony default export */ var ApostropheImgInverted = ({"src":"/_next/static/media/ApostropheImgInverted.7ed9537a.webp","height":144,"width":192,"blurDataURL":"data:image/webp;base64,UklGRqYAAABXRUJQVlA4WAoAAAAQAAAABwAABQAAQUxQSDEAAAAAABalfQAGgq8d4bUZBr3ZMqz9JgBy/2IA9f/8Xbr//5To//+2rv//8E7p6kgn0/Z4AFZQOCBOAAAA0AEAnQEqCAAGAAJAOCUAToAj7chYgAAA/smBNJvsXaq63u/rZteXhoxv9kfpOeJ/1sMzmEuYWV9qJh/nzSN/SwtTDZ2rY+z4RhnWAAAA","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/assets/images/home/youtubeIcon_1.webp
/* harmony default export */ var youtubeIcon_1 = ({"src":"/_next/static/media/youtubeIcon_1.15b8ef0f.webp","height":706,"width":1024,"blurDataURL":"data:image/webp;base64,UklGRpoAAABXRUJQVlA4WAoAAAAQAAAABwAABQAAQUxQSCsAAAABN6CgbRs21u4fqFtExN92l0JB2zaMVBCFMgAPSsOfxDhE9D86J8BAPXdOAFZQOCBIAAAAEAIAnQEqCAAGAAJAOCWwAnS6AfgAAnsb4AD+wq0GD0DR3kSVyZRfgoFPF6mPSE/+LO7pZ4h//gUEbGsq1jhb+JC/Ehf+H8AA","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/assets/images/home/Ash-Mohammad_600X300.webp
/* harmony default export */ var Ash_Mohammad_600X300 = ({"src":"/_next/static/media/Ash-Mohammad_600X300.553fb001.webp","height":625,"width":1250,"blurDataURL":"data:image/webp;base64,UklGRkgAAABXRUJQVlA4IDwAAADQAQCdASoIAAQAAkA4JagCdAD0gdD1AAD+5fhA7vweDzkIR/XGfPMn7s0ZW+aEW0/8VZCiHb7cSGm7AAA=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/assets/images/home/Testimonial2.webp
/* harmony default export */ var Testimonial2 = ({"src":"/_next/static/media/Testimonial2.74463f04.webp","height":625,"width":1250,"blurDataURL":"data:image/webp;base64,UklGRkoAAABXRUJQVlA4ID4AAADQAQCdASoIAAQAAkA4JagCdAEalYU5YAD+5fhXSa6cZIDuS6dZgJYIZQfI8mA/oPIw3+eJDVrD/niQ1IYAAA==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/assets/images/home/Testimonial-Ashutosh-Pandey.webp
/* harmony default export */ var Testimonial_Ashutosh_Pandey = ({"src":"/_next/static/media/Testimonial-Ashutosh-Pandey.462d82fd.webp","height":600,"width":1200,"blurDataURL":"data:image/webp;base64,UklGRlQAAABXRUJQVlA4IEgAAAAQAgCdASoIAAQAAkA4JbACdLoAArqJjxQAAPa6GpmTr98fnJ1nRY4hqprNXlN8k2WaWuV3cnXtErS/mfN+7wp9si9P1ZOgAAA=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/assets/images/home/Pawan-Sharma_600X300.webp
/* harmony default export */ var Pawan_Sharma_600X300 = ({"src":"/_next/static/media/Pawan-Sharma_600X300.d11f6887.webp","height":625,"width":1250,"blurDataURL":"data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAADwAQCdASoIAAQAAkA4JagCdAEXfoltaAAA/uX3QIBgc2Vr8PUNUz2yLmXmAb3mo77s0P98CQ/D+eJDVk195YTZSAAAAA==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/assets/images/home/Swaroop-Biswas-600X300.webp
/* harmony default export */ var Swaroop_Biswas_600X300 = ({"src":"/_next/static/media/Swaroop-Biswas-600X300.bd5deb8b.webp","height":600,"width":1200,"blurDataURL":"data:image/webp;base64,UklGRlgAAABXRUJQVlA4IEwAAADwAQCdASoIAAQAAkA4JbACdLoAAnYapwAA/gXlOvHn73rynil+0FjybFj3QcRyFrzfq/WD51yu8aLLNJ/79s2D5euUT0j0/VqOAAAA","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/assets/images/home/Thumbnail_Rahul_Roy-1.webp
/* harmony default export */ var Thumbnail_Rahul_Roy_1 = ({"src":"/_next/static/media/Thumbnail_Rahul_Roy-1.2db59568.webp","height":1200,"width":2400,"blurDataURL":"data:image/webp;base64,UklGRloAAABXRUJQVlA4IE4AAACQAgCdASoIAAQAAkA4JbACdLoAngD9AASjmQmSAAD+mFjJD5/pYGAaLNGyFWunck+qdK15vvBnUb0T75QR0o7Sv1JIkT2LGk5rVXwpAAA=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/assets/images/home/Thumbnail_Aakash_Garg.webp
/* harmony default export */ var Thumbnail_Aakash_Garg = ({"src":"/_next/static/media/Thumbnail_Aakash_Garg.7e59279c.webp","height":600,"width":1200,"blurDataURL":"data:image/webp;base64,UklGRlQAAABXRUJQVlA4IEgAAAAQAgCdASoIAAQAAkA4JbACdLoAAyRtc8u8AP7l+4HQCh2+xEZJ+L6eh1rfP8nD9MonFq3GaA7mUv/Oy9KObrlE7h71w4BgAAA=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/assets/images/home/testimonial-1.webp
/* harmony default export */ var testimonial_1 = ({"src":"/_next/static/media/testimonial-1.09454f71.webp","height":56,"width":56,"blurDataURL":"data:image/webp;base64,UklGRqgAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDwAAAABT6CgkdQIdGEQxT/t2oiIEILF1AHbSLbaZBAfPiWDRiiB2BaATCNIzUf0P1r+ZYUV4GiICmKAU+Dd6RNWUDggRgAAADACAJ0BKggACAACQDgljAJ0Bio2TJ+RAGIAAP3A1knNsZqgooVd/Hb+qXhxq9gi1L6uZwcfzxTEMEIbNzqO+UaHMgoAAAA=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/Testtimonial_Thumbnail_Prakash.webp
/* harmony default export */ var Testtimonial_Thumbnail_Prakash = ({"src":"/_next/static/media/Testtimonial_Thumbnail_Prakash.e08c6466.webp","height":600,"width":1200,"blurDataURL":"data:image/webp;base64,UklGRlYAAABXRUJQVlA4IEoAAAAwAgCdASoIAAQAAkA4JbACdLoAyv8DHLuzwAD+t/EDfS/A4sNuaKlQtOvPt6k+0b1zXyTfUtzof+Jo7R4fwbLk8KfbIwO1k6AAAA==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/assets/images/home/Thumbnail_Sahil_Arora.webp
/* harmony default export */ var Thumbnail_Sahil_Arora = ({"src":"/_next/static/media/Thumbnail_Sahil_Arora.8107cbc2.webp","height":600,"width":1200,"blurDataURL":"data:image/webp;base64,UklGRlQAAABXRUJQVlA4IEgAAAAQAgCdASoIAAQAAkA4JbACdLoAAyRtc8rgAP7pXUBMm3M++xEZJ+L6elB6pZH9qiSCFbon30XJu5o8P4Pra4eaDQqUlm28QAA=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/assets/images/home/Thumbnail_Krishna_Adhikari.webp
/* harmony default export */ var Thumbnail_Krishna_Adhikari = ({"src":"/_next/static/media/Thumbnail_Krishna_Adhikari.5609d6bc.webp","height":600,"width":1200,"blurDataURL":"data:image/webp;base64,UklGRlgAAABXRUJQVlA4IEwAAADwAQCdASoIAAQAAkA4JbACdLoAAnJCwgAA4miQorYTiW5TBVldgmU+c0YAsAJb1MTxKfd0CY9udD/xJu5o8P4Nljobi5UBGM8d2oAA","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./components/home/7-testimonials/Testimonials.tsx





















const testimonials = [
    Ash_Mohammad_600X300,
    Testimonial2,
    Testimonial_Ashutosh_Pandey,
    Pawan_Sharma_600X300,
    Swaroop_Biswas_600X300,
    Thumbnail_Rahul_Roy_1,
    Thumbnail_Aakash_Garg,
    testimonial_1,
    Testtimonial_Thumbnail_Prakash,
    Thumbnail_Sahil_Arora,
    Thumbnail_Krishna_Adhikari
];
const videoTestimonial = [
    "https://www.youtube.com/embed/D52nUn_m2SI?autoplay=1",
    "https://www.youtube.com/embed/c5xWuPTsRho?autoplay=1",
    "https://www.youtube.com/embed/2DtQPzOacQ4?autoplay=1",
    "https://www.youtube.com/embed/0Vn4xmTze7k?autoplay=1",
    "https://www.youtube.com/embed/E9XHIEHKDhQ?autoplay=1",
    "https://www.youtube.com/embed/Xz9FHEjsIQU?autoplay=1",
    "https://www.youtube.com/embed/cwbmdlRjhCI",
    "https://www.youtube.com/embed/sbDZpNDGUCA",
    "https://www.youtube.com/embed/YVJJUwFIBoc",
    "https://www.youtube.com/embed/8xIscsgWN0c?autoplay=1",
    "https://www.youtube.com/embed/AEycpf3OBqU?autoplay=1"
];
const responsive = {
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1024
        },
        items: 2,
        slidesToSlide: 2
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 464
        },
        items: 1,
        slidesToSlide: 1
    },
    mobile: {
        breakpoint: {
            max: 464,
            min: 0
        },
        items: 1,
        slidesToSlide: 1
    }
};
function Testimonials() {
    var ref, ref1, ref2;
    const [showVideo, setShowVideo] = (0,react.useState)(false);
    const [videoId, setVideoId] = (0,react.useState)(0);
    const playFunction = (videoId)=>{
        setShowVideo(true);
        setVideoId(videoId);
    };
    const pauseFunction = ()=>{
        setShowVideo(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        sx: {
            minHeight: {
                xs: "40vh",
                md: "70vh"
            },
            padding: {
                xs: "40px 0 20px 0",
                md: "80px 0"
            },
            width: "100%",
            backgroundColor: "#F4F7FF",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                sx: {
                    fontSize: {
                        xs: "24px",
                        md: "40px"
                    },
                    textAlign: "left",
                    width: "80%",
                    color: "#0A0C0F",
                    position: "relative",
                    zIndex: 2,
                    fontWeight: "700"
                },
                children: [
                    "Reviews from our Partners",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: ApostropheImgInverted,
                        alt: "apostropheImg",
                        style: {
                            position: "absolute",
                            left: "-8px",
                            zIndex: -1,
                            bottom: "25px",
                            width: "auto"
                        },
                        id: "ApostropheImgInverted",
                        loading: "lazy"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                sx: {
                    margin: {
                        xs: "20px 0",
                        md: "50px 0"
                    },
                    width: "80%",
                    maxWidth: "1440px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_multi_carousel["default"], {
                    autoPlay: !showVideo,
                    responsive: responsive,
                    // showDots={true}
                    containerClass: "react-multi-carousel-list",
                    itemClass: "react-multi-carousel-item",
                    infinite: true,
                    swipeable: true,
                    children: [
                        testimonials.map((testimonial, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: testimonial,
                                        alt: "testimonial-".concat(index + 1),
                                        style: {
                                            width: "545px",
                                            objectFit: "contain",
                                            height: "360px"
                                        },
                                        onClick: ()=>playFunction(index),
                                        loading: "lazy"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            width: "100%",
                                            position: "absolute",
                                            top: "32%",
                                            right: "0",
                                            left: "0"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                width: "12%",
                                                margin: "0 auto"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: youtubeIcon_1,
                                                alt: "youtubeIcon",
                                                style: {
                                                    width: "120px",
                                                    objectFit: "contain",
                                                    height: "120px"
                                                },
                                                onClick: ()=>playFunction(index),
                                                loading: "lazy"
                                            })
                                        })
                                    })
                                ]
                            }, index)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            display: "flex",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    height: "350px",
                                    width: {
                                        xs: "100%",
                                        md: "90%"
                                    },
                                    display: "grid",
                                    gridTemplateRows: "3fr 1fr",
                                    boxSizing: "border-box",
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                    background: "white",
                                    zIndex: 10
                                },
                                className: "testiCards",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        sx: {
                                            padding: {
                                                xs: "10px",
                                                md: "25px"
                                            },
                                            boxSizing: "border-box",
                                            position: "relative",
                                            overflow: "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                sx: {
                                                    fontWeight: 600,
                                                    fontSize: {
                                                        xs: "16px",
                                                        md: "24px"
                                                    },
                                                    zIndex: 3,
                                                    paddingBottom: {
                                                        xs: "10px",
                                                        md: "15px"
                                                    },
                                                    display: "block"
                                                },
                                                className: "testiHeading",
                                                children: "I earned about ₹43,000 with GroMo in last 2 months."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                sx: {
                                                    fontWeight: "400",
                                                    fontSize: {
                                                        xs: "15px",
                                                        md: "20px"
                                                    },
                                                    lineHeight: {
                                                        xs: "",
                                                        md: "32px"
                                                    }
                                                },
                                                children: "I have been working with GroMo for some time now and really like how easy it is to earn with it. I am now getting more bank and saving accounts sold and getting my payout on time."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: ApostropheImg,
                                                alt: "apostrophe",
                                                style: {
                                                    position: "absolute",
                                                    right: "2%",
                                                    top: "3%",
                                                    height: "30px",
                                                    width: "30px",
                                                    zIndex: -1
                                                },
                                                loading: "lazy"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        sx: {
                                            boxSizing: "border-box",
                                            display: "grid",
                                            gridTemplateColumns: {
                                                xs: "2.5fr 7.5fr",
                                                md: "1.5fr 8.5fr"
                                            },
                                            background: "#FFFFFF"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    display: "grid",
                                                    placeContent: "center",
                                                    padding: {
                                                        xs: "0",
                                                        md: "0"
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: testimonial_1,
                                                    alt: "GroMoPattern",
                                                    style: {
                                                        height: ((ref = globalThis.window) === null || ref === void 0 ? void 0 : ref.screen.availWidth) < 500 ? "30px" : "50px",
                                                        width: ((ref1 = globalThis.window) === null || ref1 === void 0 ? void 0 : ref1.screen.availWidth) < 500 ? "30px" : "50px",
                                                        borderRadius: "50%"
                                                    },
                                                    loading: "lazy"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    display: "grid",
                                                    placeContent: "center",
                                                    paddingLeft: {
                                                        xs: "10px",
                                                        md: "15px"
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            sx: {
                                                                fontSize: {
                                                                    xs: "13px",
                                                                    md: "20px"
                                                                },
                                                                fontWeight: "600"
                                                            },
                                                            children: "Sanjay"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            sx: {
                                                                fontSize: {
                                                                    xs: "13px",
                                                                    md: "18px"
                                                                },
                                                                fontWeight: "400",
                                                                color: "#5B6871"
                                                            },
                                                            children: "Uber Driver"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                open: showVideo,
                onClose: pauseFunction,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        position: "absolute",
                        top: "10%",
                        left: {
                            xs: "2%",
                            md: "10%"
                        },
                        width: {
                            xs: "96%",
                            md: "80%"
                        },
                        boxShadow: 24
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        sx: {
                            display: "grid",
                            placeContent: "center",
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                width: "100%",
                                height: ((ref2 = globalThis.window) === null || ref2 === void 0 ? void 0 : ref2.screen.availWidth) < 500 ? 200 : 500,
                                src: videoTestimonial[videoId],
                                title: "YouTube video player",
                                frameBorder: "0",
                                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                allowFullScreen: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                onClick: pauseFunction,
                                sx: {
                                    position: "absolute",
                                    right: "0",
                                    top: "0",
                                    fontSize: "30px",
                                    color: "#FFF",
                                    cursor: "pointer"
                                }
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var _7_testimonials_Testimonials = (Testimonials);


/***/ })

}]);